import {
  IniciadoAutorizadoAnualDemorasTotal,
  IniciadoAutorizadoAnualLineaTotal,
} from '../components';

export const IniciadoAutorizadoTotalesSection = () => {
  return (
    <>
      <IniciadoAutorizadoAnualLineaTotal />
      <IniciadoAutorizadoAnualDemorasTotal />
    </>
  );
};
